<template>
  <v-layout justify-center>
    <v-card width="90%">
      <v-card-title class="headline footer basic--text" primary-title>
        Order photos for {{ SKU }}:
      </v-card-title>
      <v-card-text>
        <draggable v-model="photos" class="row mt-4">
          <v-col cols="2" v-for="(photo, i) in photos" :key="i" class=".item">
            <v-img :src="photo" contain height="200"></v-img>
          </v-col>
        </draggable>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#66BB6A" @click="putOrderedPhotos"> Save product</v-btn>
      </v-card-actions>
    </v-card>
    <!-----------------STATUS DIALOG----------------------------------------------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <StatusInfo
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="reset"
        :textColor="textColor"
      ></StatusInfo>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </v-layout>
</template>
<script>
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "OrderPhotos",
  components: {
    StatusInfo,
  },
  props: {
    SKU: String,
  },
  data: () => ({
    photos: [],
    pending: false,
    responseMessage: "",
    filename: "",
    textColor: "basic--text",
    statusDialog: false,
  }),
  methods: {
    reset() {
      this.$router.go();
    },
    async getProductPhotos() {
      this.pending = true;
      this.statusDialog = true;
      let finalSKU = "";

      if ( this.SKU && this.SKU.includes("/")) {
        finalSKU = this.SKU.replace(/\//g, "_");
      } else {
        finalSKU = this.SKU;
      }
      setTimeout(() => this.getPhotos(finalSKU), 2000);
    },
    getPhotos(finalSKU) {
      this.$store
        .dispatch("getProductPhotos", finalSKU)
        .then((response) => {
          this.pending = false;
          this.statusDialog = false;
          this.photos = response.data;
        })
        .catch((error) => {
          console.log("error", error);
          this.pending = false;
          this.responseMessage = "Coudn't get product photos";
          this.filename = "feeling_blue.svg";
        });
    },

    putOrderedPhotos() {
      this.pending = true;
      this.statusDialog = true;
      let finalSKU = "";
      if (this.SKU.includes("/")) {
        finalSKU = this.SKU.replace(/\//g, "_");
      } else {
        finalSKU = this.SKU;
      }

      let data = {
        SKU: finalSKU,
        photos: this.photos,
      };

      this.$store
        .dispatch("putOrderedPhotos", data)
        .then(() => {
          this.textColor = "basic--text";
          this.pending = false;
          this.statusDialog = false;

          this.$emit("afterPhotosPut", this.SKU);
        })
        .catch((error) => {
          console.log("error", error);
          this.textColor = "red--text";
          this.pending = false;
          this.responseMessage = "Couldn't put ordered product photos";
          this.filename = "feeling_blue.svg";
        });
    },
  },
  mounted() {
    this.getProductPhotos();
  },
};
</script>

<style scoped>
.v-col {
  cursor: move;
}
</style>
